import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccCartAdapter } from '@spartacus/cart/base/occ';
import { Observable } from 'rxjs';
import { CustomCartAdapter } from '../../../cart/adapter/custom-cart.adapter';

@Injectable()
export class CustomOccCartAdapter extends OccCartAdapter implements CustomCartAdapter {
  addExtraData(userId: string, cartId: string, extraData: {}): Observable<{}> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.occEndpointsService.buildUrl('cart', {
      urlParams: {
        userId,
        cartId,
      }
    });
    return this.http.patch(url, extraData, { headers });
  }
}
